/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MetaService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * KM API Root
     * @returns any Success
     * @throws ApiError
     */
    public about(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/about',
        });
    }

}
